<template>
  <div>New Incidence</div>
</template>

<script>
export default {};
</script>

<style></style>
